import { useState, useEffect, useCallback } from 'react';
import { getPlanUsages } from '../services/settings/subscriptions';

// Fetches organization subscription usage data for listing pages
export const useUsageIndicator = () => {
  const [usageData, setUsageData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUsage = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getPlanUsages();
      setUsageData(data);
    } catch (err) {
      console.error('Failed to load usage data:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUsage();
  }, [fetchUsage]);

  return { usageData, loading, refetch: fetchUsage };
};

export default useUsageIndicator;
